import { Viewer } from '@oneclick/tangerine-viewer';
import { defaultConfig } from 'app/config/environment';
import PropTypes from 'prop-types';
import React from 'react';
import { Loading } from 'ui';

function ViewerContainerEmbed({
  showHeader,
  authToken,
  courseGuid,
  lang,
  user,
  contentGuid,
  pdfConfig,
  controllersConfig,
  pagesRangeShow,
  pdfLibrary = '',
  isViewerPending = false,
  jobGuid,
  docConfig,
  reportErrorSentry,
  scormMetadata,
  goToBackViewer,
  externalContentUrl,
  onContentLoaded,
  onOpenExternal,
  contained = false,
  skinConfig,
}) {
  return (
    <div className="viewer-v2" style={{ position: 'relative', height: '100%', width: '100%' }}>
      {isViewerPending ? (
        <Loading isFullScreen={false} />
      ) : (
        <Viewer
          authToken={authToken}
          contentGuid={contentGuid}
          controllersConfig={controllersConfig}
          courseGuid={courseGuid}
          domain={defaultConfig.BASE_URL_}
          lang={lang}
          pagesRangeShow={pagesRangeShow}
          pdfConfig={pdfConfig}
          scormMetadata={scormMetadata}
          showHeader={showHeader}
          pdfLibrary={pdfLibrary}
          user={user}
          jobGuid={jobGuid}
          docConfig={docConfig}
          reportErrorSentry={reportErrorSentry}
          onClose={goToBackViewer}
          externalContentUrl={externalContentUrl}
          onContentLoaded={onContentLoaded}
          onOpenExternal={onOpenExternal}
          contained={contained}
          skinConfig={skinConfig}
        />
      )}
    </div>
  );
}

ViewerContainerEmbed.propTypes = {
  authToken: PropTypes.string.isRequired,
  contentGuid: PropTypes.string.isRequired,
  controllersConfig: PropTypes.object,
  courseGuid: PropTypes.string.isRequired,
  lang: PropTypes.string.isRequired,
  pagesRangeShow: PropTypes.array,
  pdfConfig: PropTypes.arrayOf(PropTypes.string),
  pdfLibrary: PropTypes.string,
  isViewerPending: PropTypes.bool,
  showHeader: PropTypes.bool,
  user: PropTypes.object.isRequired,
  jobGuid: PropTypes.string,
  docConfig: PropTypes.object,
  reportErrorSentry: PropTypes.func,
  scormMetadata: PropTypes.object,
  goToBackViewer: PropTypes.func,
  externalContentUrl: PropTypes.string,
  onContentLoaded: PropTypes.func,
  onOpenExternal: PropTypes.func,
  contained: PropTypes.bool,
  skinConfig: PropTypes.shape({
    brandColors: PropTypes.shape({ primary: PropTypes.string, secondary: PropTypes.string }),
    level: PropTypes.string,
    role: PropTypes.string,
  }),
};

export default ViewerContainerEmbed;
